"use client";

import { Button } from "@/modules/system/components/ui/button";
import { useAuth } from "../hooks/use-auth";
import { RiGoogleFill } from "@remixicon/react";

interface GoogleSignInButtonProps {
  className?: string;
}

export function GoogleSignInButton({ className }: GoogleSignInButtonProps) {
  const { login, isLoading } = useAuth();

  return (
    <Button
      variant="outline"
      className={className}
      disabled={isLoading}
      onClick={login}
    >
      <RiGoogleFill className="mr-2 size-4" />
      Sign in with Google
    </Button>
  );
} 